exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@page{margin:2cm;@top-center{content:element(pageHeader)}@bottom-center{content:element(pageFooter)}}#pageHeader{position:running(pageHeader)}#pageFooter{position:running(pageFooter)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/components/Screens/ContentGrid/poPrint.css
// module id = 372
// module chunks = 0